/**
 * Created by tomere on 14/08/2017.
 */
import Model from './Model';

export default class AttributesModel extends Model {

	constructor(data) {
		super(data);

		this.name = data.name;
		this.values = '';
		this.valuesDelimiter = data.valuesDelimiter || ';';

		if (data.values && Array.isArray(data.values)) {
			this.values = data.values.join(this.valuesDelimiter);
		} else if (data.values && typeof data.values === 'string') {
			this.values = data.values;
		}
	}

	build(customNameKey, customValuesKey, allowSingleValue) {
		let buildResult = {},
			name = this.name,
			values = allowSingleValue ? this.values : this.values.split(this.valuesDelimiter);
		if(customNameKey) {
			buildResult[customNameKey] = name;
		} else {
			buildResult.name = name;
		}
		if(customValuesKey) {
			buildResult[customValuesKey] = values;
		} else {
			buildResult.values = values;
		}
		return buildResult;
	}
}


// WEBPACK FOOTER //
// ./modules/distribution/core/models/AttributesModel.js